import FrontApplet from './FrontApplet';

export default function createFrontApplet(window: Window, messagePrefix: string) {
	const frontApplet: FrontApplet = new FrontApplet(window, messagePrefix);
	return frontApplet;
}
